module.exports = __webpack_public_path__ + "fddfc4580917ad123cb8859e52544ffb.jpg";